import React, { useState } from 'react'
import MainLayout from '../layout/MainLayout'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import GradientSlider from '../components/GradientSlider';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

function Register() {
    const navigate = useNavigate();

    const [stateOptions, setStateOptions] = useState([]);

    const populateStateOptions = async => {
        axios.get("/api/v1/states")
            .then((response) => {
                setStateOptions(response.data);
            })
    }

    function handleSubmit(formData) {
        if (formData.get("password") != formData.get("passwordVerify")) {
            alert("Passwords don't match");
            return;
        } else {
            setSubmitDisabled(true);

            let tmpData = JSON.stringify({
                username: formData.get("name"),
                email: formData.get("email"),
                password: formData.get("password"),
                party: sliderValue,
                state: formData.get("residentState"),
                congressionalDistrict: formData.get("congressionalDistrict")
            });

            axios.post("/api/v1/auth/signup", tmpData, {
                headers: { 'Content-type': 'application/json' }
            })
                .then((response) => {
                    alert("You've been registered. Please check your email to activate your account.");
                    navigate("/");
                })
                .catch((err) => {
                    if (err.response.status == 400) {
                        alert(err.response.data.message);
                    }
                });
        }
        setSubmitDisabled(false);
    }

    const [password, setPassword] = useState('');
    const [isValid, setIsValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [passwordVerify, setPasswordVerify] = useState('');
    const [isMatch, setIsMatch] = useState(false);
    const [matchErrorMessage, setErrorMessageVerify] = useState('');


    const handlePasswordChange = (event) => {
        const tmpPassword = event.target.value;
        setPassword(tmpPassword);

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (passwordRegex.test(tmpPassword)) {
            setIsValid(true);
            setErrorMessage('');
        } else {
            setIsValid(false);
            setErrorMessage('Must have 8 charachters, upper and lower case letters, numbers, plus any of these (@$!%*?&)');
        }
    };
    const handlePasswordCheck = (event) => {
        const tmpPassword = event.target.value;
        setPasswordVerify(tmpPassword);
        if (password != tmpPassword) {
            setIsMatch(false);
            setErrorMessageVerify('passwords don\'t match');
        } else {
            setIsMatch(true);
            setErrorMessageVerify('');
        }
    }

    const [userName, setUserName] = useState('');
    const handleUserNameChange = (event) => {
        setUserName(event.target.value);
    }

    const [email, setEmail] = useState('');
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    }

    const [residentState, setResidentState] = useState();
    const [stateReps, setStateReps] = useState();
    const handleStateChange = (event) => {
        let val = event.target.value;
        setResidentState(val);
        stateOptions.forEach((st, index) => {
            if (st.abbreviation == val) {
                setStateReps(st.representatives);
            }
        })
    }

    const [congressionalDistrict, setCongressionalDistrict] = useState();
    const handleCongressionalDistrictChange = (event) => {
        setCongressionalDistrict(event.target.value);
    }




    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [showUserNameInfo, setUserNameInfo] = useState();
    const [showEmailInfo, setEmailInfo] = useState();
    const [showPasswordInfo, setPasswordInfo] = useState();
    const [showDistrictInfo, setShowDisctrictInfo] = useState();
    const [showStateInfo, setShowStateInfo] = useState();

    const toggleUserNameInfo = () => {
        setUserNameInfo(!showUserNameInfo);
    }
    const toggleEmailInfo = () => {
        setEmailInfo(!showEmailInfo);
    }
    const togglePasswordInfo = () => {
        setPasswordInfo(!showPasswordInfo);
    }
    const toggleStateInfo = () => {
        setShowStateInfo(!showStateInfo);
    }
    const toggleDistrictInfo = () => {
        setShowDisctrictInfo(!showDistrictInfo);
    }

    const [sliderValue, setSliderValue] = useState(0);

    const handleSliderChange = (newValue) => {
        setSliderValue(newValue);
    };

    useEffect(() => {
        populateStateOptions();
    }, []);


    return (
        <div>
            <MainLayout>
                <div className="registration-page">
                    <h1>Registration</h1>
                    <p>Registration is required in order to read and participate in the debates.
                        If you choose not to register, you still have access to the political documents
                        in our repository as well as the Summaries, and Conservative and Liberal
                        opinions.</p>
                    <br /><br />
                    <form action={handleSubmit}>
                        <img alt='information' src='/graphics/icons/info-circle.svg' onClick={() => toggleUserNameInfo()} ></img>
                        {showUserNameInfo &&
                            <p>Your user name is going to be how you're identified on the site.
                                Comments and debates you engage in will be labeled with your user name.</p>
                        }
                        <label>User Name</label>
                        <input name="name" type="text" size="50" required value={userName} onChange={handleUserNameChange} />

                        <br /><br />
                        <img alt='information' src="/graphics/icons/info-circle.svg" onClick={() => toggleEmailInfo()}></img>
                        {showEmailInfo &&
                            <p>Your email address is only used to verify that you're a person and to
                                send you notifications based on your preferences.
                                We encrypt your email address before we store it in our database, and the
                                password to unencrypt that data is not even stored on the same server as the
                                database or the web server.</p>
                        }
                        <label>Email</label>
                        <input name="email" type="email" size="50" required value={email} onChange={handleEmailChange} />
                        <br /><br />

                        <img alt='information' src="/graphics/icons/info-circle.svg" onClick={() => toggleStateInfo()}></img>
                        {showStateInfo &&
                            <p>This helps us with statistics and identiying ares of your interest such as congressional and state-level elections
                            </p>
                        }
                        <label>Your state</label>
                        <select value={residentState} onChange={handleStateChange}>
                            {stateOptions.map((st, index) => (
                                <option key={index} value={st.abbreviation}>{st.name}</option>
                            ))}

                        </select>
                        <br /><br />

                        <img alt='information' src="/graphics/icons/info-circle.svg" onClick={() => toggleDistrictInfo()}></img>
                        {showDistrictInfo &&
                            <p>This helps us with statistics and identifying areas of your interest such as congressional and state-level elections
                            </p>
                        }
                        <label>Congressional District</label>
                        <select value={congressionalDistrict} onChange={handleCongressionalDistrictChange} >
                            {Array.from({ length: stateReps }, (_, i) => i + 1).map((dis, index) => (
                                <option key={index} value={dis}>{dis}</option>
                            ))
                            }
                        </select>
                        &nbsp; &nbsp;<a href="https://ziplook.house.gov/" target="_blank" rel="noreferrer">Find my district &#128471;</a>
                        <br /><br />
                        <label htmlFor="politicalLeanings">Where do you sit on the political scale?</label>
                        <Link to="/WhereDoILean.html">Which Way Do I Lean</Link>

                        <GradientSlider style={{ width: '100%' }} value={sliderValue} onChange={handleSliderChange} />

                        <br /><br />
                        <img alt='information' src="/graphics/icons/info-circle.svg" onClick={() => togglePasswordInfo()}></img>
                        {showPasswordInfo &&
                            <p>We DO NOT save your password. We use an industry standard hashing algorhythm
                                when storing your password. The beauty of the hash is that it's a one-way
                                function, meaning the even if our system is compromised, nobody should be
                                able to reverse engineer the hash into your password. Each time you use
                                your password on this site, it is converted to a string of hashed bytes,
                                and that's what gets compared to our database.
                                Note, this is <i>different</i> than the encryption we use on your email address.
                            </p>
                        }
                        <label htmlFor="password">Password</label>
                        <input name="password" id="password" type="password" size="50" required value={password} onChange={handlePasswordChange} />
                        {!isValid && <p style={{ color: 'red' }}>{errorMessage}</p>}


                        <br />
                        <label htmlFor="passwordVerify">Verify password</label>
                        <input name="passwordVerify" id="passwordVerify" type="password" size="50" required value={passwordVerify} onChange={handlePasswordCheck} />
                        {!isMatch && <p style={{ color: 'red' }}>{matchErrorMessage}</p>}


                        <br /><br />
                        <input type="submit" disabled={submitDisabled} />

                    </form>
                </div>
            </MainLayout>
        </div>
    )
}

export default Register;
